import clsx from 'clsx'
import includes from 'lodash/includes'
import React, { useContext } from 'react'

import { BlockContainer } from '@Components/BlockContainer'
import { RTEContent } from '@Components/RTEContent'
import { Block, PagePresentation } from '@Generated/graphql'
import { BlockContext } from '@Globals/CMS/Context'
import { getRTEFieldText } from '@Globals/CMS/FieldHelpers'
import { MetadataContext } from '@Globals/Metadata'

import styles from './TextBlock.module.scss'

const TextBlock = ({
  data,
  id,
}: {
  data: Block
  id?: string
}) => {
  const { presentation } = React.use(BlockContext)
  const { appearance, common } = data
  const text = getRTEFieldText(data.fields || [], 'text')
  const { page } = useContext(MetadataContext)

  if (!text) {
    return null
  }

  if (!appearance && presentation !== PagePresentation.Sidebar) {
    return (
      <div
        className={clsx(
          styles.textContainer,
          styles.v1,
          includes(['frontpages', 'category', 'filters'], page?.type) && styles.fullWidth,
        )}
        id={id}
      >
        <RTEContent html={text} />
      </div>
    )
  }

  const fullWidth = [PagePresentation.Modal, PagePresentation.Sidebar].includes(presentation)

  return (
    <BlockContainer
      appearance={appearance || {}}
      className={clsx(fullWidth && 'fullwidth')}
      common={common || {}}
      id={id}
      noPadding={fullWidth}
      presentation={presentation}
    >
      <div className={clsx(styles.textContainer, styles.v2)}>
        <RTEContent html={text} />
      </div>
    </BlockContainer>
  )
}

export default TextBlock
